export default __webpack_public_path__ + "static/media/empty-betslip.820a0507.png";